// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vsEm","colMin":"styles_colMin__3N2x_"};